<script setup
        lang="ts"
>
import BaseCheckbox from '@/js/vue/base/base-checkbox.vue';
import BaseIcon from '@/js/vue/base/base-icon.vue';

type ItemOption = {
  id: string
  value: string
  count: number
};

const props = defineProps<{
  name: string
  options: ItemOption[]
  openByDefault?: boolean
}>();

const values = defineModel<string[] | undefined>('values', { required: true });

function updateOptionsValues(checked: boolean, option: string) {
  let selectedOptions = values.value || [];
  if (checked) {
    selectedOptions.push(option);
  }
  else {
    selectedOptions = selectedOptions.filter(item => item !== option);
  }

  values.value = selectedOptions;
}

// Count only once
const openByDefault = (values.value && values.value.length > 0) || props.openByDefault;
</script>

<template>
  <details class="filters__details" :open="openByDefault">
    <summary class="filters__summary">
      <span v-html="name" />
      <BaseIcon
        type="main"
        icon="chevron"
        :width="16"
        :height="16"
        class="filters__summary-icon"
      />
    </summary>
    <div class="filters__details-content">
      <div class="filters__options">
        <BaseCheckbox
          v-for="option in options"
          :key="option.id"
          class="js-floating-container"
          :model-value="values?.includes(option.id) || false"
          :disabled="!values?.includes(option.id) && option.count === 0"
          @update:model-value="updateOptionsValues($event, option.id)"
        >
          <span v-html="option.value" />
          <small class="filters__check-option-count">
            ({{ option.count }})
          </small>
        </BaseCheckbox>
      </div>
    </div>
  </details>
</template>

<style scoped
       lang="scss"
></style>
